import {
  FilePreviewBody,
  FilePreviewHeader,
} from "../../../components/FilePreview";
import { ModalShell } from "../../../components/Modal";

/* ── Diagram Preview Modal ──
   Thin shell around the shared preview engine (src/app/components/FilePreview),
   same as the Content Registry PreviewModal but wrapped in ModalShell and with
   a caller-supplied title. */
export function DiagramPreviewModal({
  url,
  fileName,
  downloadUrl,
  title,
  onClose,
}: {
  url: string;
  fileName: string | null;
  downloadUrl: string;
  title: string;
  onClose: () => void;
}) {
  return (
    <ModalShell open onClose={onClose} variant="preview">
      <FilePreviewHeader
        title={title}
        fileName={fileName}
        downloadUrl={downloadUrl}
        onClose={onClose}
      />
      <FilePreviewBody url={url} fileName={fileName} />
    </ModalShell>
  );
}
